import { graphql } from "gql";

const INTERNAL_ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION = graphql(`
  mutation InternalAdminGrantHistoricalAccess(
    $organizationId: ID!
    $distributionGroupId: ID!
    $userId: ID!
  ) {
    internalAdminGrantHistoricalAccess(
      organizationId: $organizationId
      distributionGroupId: $distributionGroupId
      userId: $userId
    ) {
      ...DistributionGroup
    }
  }
`);

export default INTERNAL_ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION;
